module.exports = __webpack_public_path__ + "static/media/battyboy.7959ae58.mp3";